import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import PageBanner from '../components/PageBanner';
import Services from '../components/Services';

const ServicesPage = () => {
  const { t } = useLang();
  return (
    <>
      <PageBanner tag={t.services.tag} title={t.services.title} />
      <Services hideHeader />
    </>
  );
};

export default ServicesPage;
